module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "page-loading"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line-3"
  }, [_c('div', {
    staticClass: "progress-rate"
  }, [_c('div', {
    staticClass: "progress-ok",
    style: (_vm.loading_style)
  }, [(_vm.loadingPercentage > 20) ? _c('div', {
    staticClass: "progress-hide"
  }, [_vm._v("\n          " + _vm._s(_vm.loadingPercentage + '%') + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "jiao-tl"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-rb"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-zl"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-zr"
  }), _vm._v(" "), _c('a', {
    staticClass: "close-loading",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.loading = false
      }
    }
  }, [_vm._v("\n  X\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "loading-title-block"
  }, [_c('span', {
    staticClass: "icon-1"
  }, [_vm._v("》")]), _c('span', {
    staticClass: "loading-title"
  }, [_vm._v("》" + _vm._s(_vm.loadingText))]), _c('span', {
    staticClass: "icon-2"
  }, [_vm._v("《")]), _c('span', {
    staticClass: "icon-1"
  }, [_vm._v("《 ")]), _vm._v("    \n  ")]), _vm._v(" "), _vm._m(3)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-1"
  }, [_c('div', {
    staticClass: "line-1-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-1-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-1-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-2"
  }, [_c('div', {
    staticClass: "line-2-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content"
  }, [_c('div', {
    staticClass: "line-2-content-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content-3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-4"
  }, [_c('div', {
    staticClass: "line-4-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-4-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-loading-block"
  }, [_c('span', {
    staticClass: "loading-text"
  }, [_vm._v("Loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ee903a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/Loading.vue
// module id = 787
// module chunks = 1